// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { enableEnglishDigits } from "./englishDigits";

// ✅ أي رقم عربي ينكتب بالحقول يتحول تلقائياً لرقم إنكليزي
enableEnglishDigits();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// ✅ تسجيل Service Worker الخاص بالإشعارات
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.log("✅ Service Worker registered:", registration);
    })
    .catch((err) => {
      console.log("❌ Service Worker registration failed:", err);
    });
}
// ✅ تفعيل الـ service worker (PWA) لتفعيل الإشعارات حتى والموقع مغلق
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then((reg) => console.log("✅ Service Worker Registered:", reg.scope))
      .catch((err) => console.error("❌ SW registration failed:", err));
  });
}
